import { Tabs } from "devextreme-react";
import { useCallback, useState } from "react";
import Configuration from "./Configuration";
import PaymentStatus from "./PaymentStatus";
import Vendor from "./Vendor";
import Report from "./Report";

export default function Payment(props) {
  // console.debug("[Payment]");

  const { handleClickMenu } = props;
  //   const dataSource = [
  //     {
  //       // text: "",
  //       type: "configuration",
  //       icon: "preferences",
  //       // badge: "New",
  //     },
  //     {
  //       text: "Payment Status",
  //       type: "paymentStatus",
  //     },
  //     {
  //       text: "EDC",
  //       type: "EDC",
  //     },
  //     {
  //       text: "Report",
  //       type: "report",
  //     },
  //   ];

  const [dataSource, setDataSource] = useState([
    {
      // text: "",
      type: "configuration",
      icon: "preferences",
      // badge: "New",
    },
    {
      text: "Payment Status",
      type: "paymentStatus",
    },
    {
      text: "Vendor",
      type: "vendor",
    },
    // {
    //   text: "Report",
    //   type: "report",
    // },
  ]);

  const [cTab, setCTab] = useState("paymentStatus");

  const itemRender = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.icon && <i className="dx-icon-preferences" />}
        {e.text}
      </div>
    );
  };

  const onItemClick = (e) => {
    setCTab(e.itemData.type);
  };

  return (
    <>
      <Tabs
        dataSource={dataSource}
        defaultSelectedIndex={1}
        height={40}
        // width={450}
        width={"auto"}
        itemRender={itemRender}
        onItemClick={onItemClick}
      />
      <div style={{ height: "16px" }} />
      {cTab == "configuration" ? (
        <Configuration />
      ) : cTab == "paymentStatus" ? (
        <PaymentStatus handleClickMenu={handleClickMenu} />
      ) : cTab == "vendor" ? (
        <Vendor />
      ) : (
        <Report />
      )}
    </>
  );
}
